import Image from "next/image";

export function AppLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative w-8 h-8 mr-2">
        <Image
          src="/icon_full_res.png"
          alt="VisualGrid Logo"
          fill
          className="object-contain"
          priority
        />
      </div>
    </div>
  );
} 